export default class ApiService {

	static get $inject(){
		return [
			'$q', '$http', '$cookies',
			'ApiService',
		];
	}

	constructor($q, $http, $cookies,
	            ApiService){

		this._api = ApiService.api;

		this._$q = $q;
		this.$http = $http;
		this._$cookies = $cookies;

	}


    getLatestDectHomeAutomationMeasurements(panelId){

        return this.$http({
            url: `${this._api}/panels/${panelId}/dect/measurements/latest/`,
            method: 'GET'
        });

    }

    getLatestByZoneDectHomeAutomationMeasurements(panelId){

        return this.$http({
            url: `${this._api}/panels/${panelId}/dect/measurements/latest/by_zone/`,
            method: 'GET'
        });

    }

	connect(data){
		return this.$http({
			url: this._api + '/personal/access/connect',
			method: 'PUT',
			data: data
		});
	}

	disconnect(){
		return this.$http({
			url: this._api + '/personal/access/disconnect',
			method: 'PUT',
			data: {}
		});
	}

	addToAccount(data){
		return this.$http({
			url: this._api + '/panels/',
			method: 'POST',
			data: data
		});
	}


	deletePanelFromAccount(panelId){
		return this.$http({
			url: this._api + `/panels/${panelId}/`,
			method: 'DELETE'
		});
	}

	getConfig(){
		return this.$http({
			url: this._api + '/personal/access/config',
			method: 'GET'
		});
	}

	getStatus(){
		return this.$http({
			url: this._api + '/personal/access/status',
			method: 'GET'
		});
	}


	// --- Actions -----------------------------------------------------------------------------------------------------

	// General
	setAlarmPanic(data){
		return this.$http({
			url: this._api + '/personal/access/alarm/panic',
			method: 'PUT',
			data: data
		});
	}

	resetGeneralAlarms(panelId){
		return this.$http({
			url: this._api + '/panels/' + panelId + '/troubles/',
			method: 'DELETE',
		});
	}

	//troubles
	getTroubles(panelId){
		return this.$http({
			url: this._api + '/panels/' + panelId + '/troubles/',
			method: 'GET',
		});
	}

	// Areas
	setArea(panelId, areaId, state, force){

		return this.$http({
			url: this._api + '/panels/' + panelId + '/areas/' + areaId + '/',
			method: 'PATCH',
			data: {"state": state, "force": force}
		});
	}

	setAreaReset(areaId, data = {}){
		return this.$http({
			url: this._api + '/personal/access/area/' + areaId + '/reset',
			method: 'PUT',
			data: data
		})
	}

	// Zones
	// bypassZone(zoneId, data = {}){
	// 	return this.$http({
	// 		url: this._api + '/personal/access/zone/' + zoneId,
	// 		method: 'PUT',
	// 		data: data
	// 	})
	// }

	takePicture(zoneId, data = {}){
		return this.$http({
			url: this._api + '/personal/access/zone/' + zoneId + '/takePicture',
			method: 'PUT'
		});
	}

	// Outputs
	setOutput(panelId, outputId, state){
		return this.$http({
			url: this._api + '/panels/' + panelId + '/outputs/' + outputId + '/',
			method: 'PATCH',
			data: {"state": state}
		})
	}

	getOutputsConfigList(panelId){

		return this.$http.get(this._api + '/panels/' + panelId + /outputs/);

	}

	getDoorLocksConfigList(panelId){
		return this.$http.get(this._api + '/panels/' + panelId + /doorlocks/)
	}

	setDoorLock(panelId, doorLockId, state){
		return this.$http({
			url: this._api + '/panels/' + panelId + '/doorlocks/' + doorLockId + '/',
			method: 'PATCH',
			data: {"locked": state}
		})
	}

	getZonesConfigList(panelId){

		return this.$http.get(this._api + '/panels/' + panelId + /zones/);

	}

	getAreasConfigList(panelId){

		return this.$http.get(this._api + '/panels/' + panelId + /areas/);

	}

	setZoneBypass(panelId, zoneId, bypass){

		return this.$http({
			url: this._api + '/panels/' + panelId + '/zones/' + zoneId + '/',
			method: 'PATCH',
			data: {"bypass": bypass}
		});
	}

    //users
    getUsers(panelId) {
        return this.$http.get(`${this._api}/panels/${panelId}/users/`);
    }


    //Keypads
    getKeypadsConfigList(panelId) {
        return this.$http.get(this._api + '/panels/' + panelId + '/keypads/');
    }

	// panic
    setPanicAlarm(panelId){

		return this.$http({
			url: this._api + '/panels/' + panelId + '/panic/',
			method: 'PUT',
		});
	}

	getPanicAlarmState(panelId){

		return this.$http({
			url: this._api + '/panels/' + panelId + '/panic/',
			method: 'GET',
		});
    }

}


/** WEBPACK FOOTER **
 ** ./src/services/api/api.remote.service.js
 **/